"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _d3Array = require("d3-array");

var _JSUtils = require("../../JSUtils");

var _utils = require("../../utils");

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  var data = props.data,
      lineAttrs = props.lineAttrs,
      plotStyle = props.plotStyle;
  if (!data || !Array.isArray(data) || data.length === 0) return null;
  var isNumeric = true;
  data.forEach(function (e) {
    if (!(0, _JSUtils.isNumber)(e)) {
      isNumeric = false;
    }
  });
  if (!isNumeric) return null;
  var W = 100,
      H = plotStyle && plotStyle.height || 100,
      limit = 5;
  var data_sorted = data.sort(_d3Array.ascending);
  data_sorted = data_sorted.map(function (e) {
    return (0, _utils.convertRange)(e, {
      oldMax: data_sorted[data_sorted.length - 1],
      oldMin: data_sorted[0],
      newMax: W - 5,
      newMin: 5
    });
  });
  var q1 = +(0, _d3Array.quantile)(data_sorted, .25).toFixed(2);
  var median = +(0, _d3Array.quantile)(data_sorted, .5).toFixed(2);
  var q3 = +(0, _d3Array.quantile)(data_sorted, .75).toFixed(2);
  var interQuantileRange = +(q3 - q1).toFixed(2);
  var min = +(q1 - 1.5 * interQuantileRange).toFixed(2);
  var max = +(q1 + 1.5 * interQuantileRange).toFixed(2);
  var outliers = data_sorted.filter(function (e) {
    return e > max || e < min;
  });
  var Y = 5,
      yHeight = 60,
      yMiddle = Y + yHeight / 2;
  var scale = data;

  if (data.length > limit) {
    scale = [];
    data.forEach(function (item, idx) {
      var d = Math.floor(data.length / limit);
      if (d === 1) d = 2;

      if (idx % d === 0) {
        var l = Math.floor(item);
        if (l > 1000) l = (l / 1000).toFixed(1) + "k";
        scale.push(l);
      }
    });
  }

  return _react["default"].createElement("div", {
    style: {
      width: '100%',
      height: H,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, _react["default"].createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      maxWidth: '600px'
    }
  }, _react["default"].createElement("svg", {
    width: "100%",
    height: "100%"
  }, _react["default"].createElement("g", {
    style: {
      stroke: plotStyle && plotStyle.lineColor || 'rgb(18, 147, 154)'
    }
  }, _react["default"].createElement("line", _extends({
    x1: min + "%",
    x2: q1 + "%",
    y1: yMiddle + "%",
    y2: yMiddle + "%"
  }, lineAttrs)), _react["default"].createElement("line", _extends({
    style: {
      strokeWidth: 1
    },
    x1: min + "%",
    x2: min + "%",
    y1: Y + "%",
    y2: Y + yHeight + "%"
  }, lineAttrs)), _react["default"].createElement("line", _extends({
    x1: max + "%",
    x2: q3 + "%",
    y1: yMiddle + "%",
    y2: yMiddle + "%"
  }, lineAttrs)), _react["default"].createElement("line", _extends({
    style: {
      strokeWidth: 1
    },
    x1: max + "%",
    x2: max + "%",
    y1: Y + "%",
    y2: Y + yHeight + "%"
  }, lineAttrs)), _react["default"].createElement("rect", {
    x: q1 + "%",
    width: interQuantileRange + "%",
    y: Y + "%",
    height: yHeight + "%",
    fill: plotStyle && plotStyle.fillColor || 'rgb(18, 147, 154)',
    stroke: "black 0.5px"
  }), _react["default"].createElement("line", _extends({
    style: {
      stroke: 'black',
      strokeWidth: 1
    },
    x1: median + "%",
    x2: median + "%",
    y1: Y + "%",
    y2: Y + yHeight + "%"
  }, lineAttrs)), outliers.map(function (e, i) {
    return _react["default"].createElement("circle", {
      key: e + "-" + i,
      r: "5",
      cx: (e > max ? e + 2 : e - 2) + "%",
      cy: yMiddle + "%",
      style: {
        fill: 'none',
        opacity: 1
      }
    });
  }), scale && scale.map(function (v, i) {
    var x1 = i * (W / scale.length);
    return _react["default"].createElement("g", {
      key: x1 + "-" + i
    }, _react["default"].createElement("text", {
      x: x1 + 2 + "%",
      y: "85%",
      className: "d3-axis-labels"
    }, v));
  })))));
};

exports["default"] = _default;